import { forwardRef, memo } from "react";
import { Input } from "./input";
import { Label } from "./label";
import { cn } from "@/utilities/app-utils";

interface FormFieldProps {
  id: string;
  label?: string;
  value?: string | number | readonly string[];
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  placeholder: string;
  type?: string;
  required?: boolean;
  maxLength?: number;
  min?: number;
  max?: number;
  className?: string;
  disabled?: boolean;
  error?: string;
}

export const FormField = memo(
  forwardRef<HTMLInputElement, FormFieldProps>(
    (
      {
        id,
        label,
        value,
        onChange,
        onFocus,
        onBlur,
        placeholder,
        type = "text",
        maxLength = 255,
        min,
        max,
        className,
        disabled,
        required,
        error
      }: FormFieldProps,
      ref
    ) => {
      return (
        <div className={cn("flex flex-col gap-2", className)}>
          {label && (
            <Label htmlFor={id}>
              {label}
              {required && <span className="text-destructive">*</span>}
            </Label>
          )}
          <Input
            id={id}
            value={value || ""}
            onChange={onChange}
            onFocus={onFocus}
            onBlur={onBlur}
            placeholder={placeholder}
            type={type}
            maxLength={maxLength}
            spellCheck="false"
            min={min}
            max={max}
            required={required}
            disabled={disabled}
            ref={ref}
          />
          {error && <p className="text-xs text-destructive mt-0.5">{error}</p>}
        </div>
      );
    }
  )
);

FormField.displayName = "FormField";
